import { TextField } from '@shopify/polaris';

export type AppearanceNumberDraft = { text: string; value: number };

type Props = {
    label: string; value: number; min: number; max: number; unit?: string;
    draft?: AppearanceNumberDraft;
    onDraftChange: (draft: AppearanceNumberDraft | undefined) => void;
    onCommit: (value: number) => void;
};

export default function AppearanceNumberField({ label, value, min, max, unit, draft, onDraftChange, onCommit }: Props) {
    const change = (text: string) => {
        const parsed = Number(text);
        const next = text.trim() && Number.isFinite(parsed) ? Math.max(min, Math.min(max, Math.round(parsed))) : value;
        // Report pending edits immediately, keeping the typed text separate from
        // the validated value so clearing/replacing a number never interrupts typing.
        onDraftChange(text === String(value) ? undefined : { text, value: next });
    };
    const commit = () => {
        const next = draft?.value ?? value;
        if (next !== value) onCommit(next);
        onDraftChange(undefined);
    };
    return <TextField label={label} type="number" autoComplete="off" value={draft?.text ?? String(value)} min={min} max={max} suffix={unit}
        onChange={change} onBlur={commit} />;
}
